import DataTable from 'react-data-table-component'
import Modal from 'react-bootstrap/Modal'
import {useEffect, useMemo, useState, useRef} from 'react'

import 'react-datepicker/dist/react-datepicker.css'
import {Link} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import Swal from 'sweetalert2'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEdit, faTrash} from '@fortawesome/free-solid-svg-icons'
import { Tr } from '../../../../_metronic/i18n/Tr'
import { fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../../reusable'
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers'



  const Popup = (props: any) => {
      let t = Tr()

    // add / edit facility states
    const [cancellationreasonId] = useState(props.cancellationreasonId)
    const [enReason, setEnReason] = useState('')
    const [ruReason, setRuReason] = useState('')
    const [uzReason, setUzReason] = useState('')
    const [error, setError] = useState(Object)
    const [addloader, setaddLoader] = useState(false)
    const [disable, setDisable] = useState(false)

    const saveCancellationReason = async () => {
      setDisable(true)

      let param: any = {
        en_reason: enReason,
        ru_reason: ruReason,
        uz_reason: uzReason,
      }

      if (
        props.cancellationreasonId != '' &&
        props.cancellationreasonId != null &&
        props.cancellationreasonId > 0
      ) {
        param.cancellationreasonId = props.cancellationreasonId
      }

      var res = await fetchData('admin/addeditcancellationreasonasync', param)
      if (res.status == '200') {
        toastsuccessmsg(res.message)
        setDisable(false)
        props.onHide()
      } else {
        setDisable(false)
        toasterrormsg(res.message)
      }
    }
    const validate = () => {
      var errotmp: any = {}
      var err = 0
      if (enReason.trim() == '' || enReason.trim() == null || enReason.trim() == undefined) {
        errotmp['enReasonError'] = t('Cancellation Reason English Is Required')
        err = 1
      }
      if (ruReason.trim() == '' || ruReason.trim() == null || ruReason.trim() == undefined) {
        errotmp['ruReasonError'] = t('Cancellation Reason Russian Is Required')
        err = 1
      }

      if (uzReason.trim() == '' || uzReason.trim() == null || uzReason.trim() == undefined) {
        errotmp['uzReasonError'] = t('Cancellation Reason Uzbek Is Required')
        err = 1
      }
      setError(errotmp)
      if (err == 0) {
        saveCancellationReason()
      }
    }
    const cancellationReasonDetails = async (catlist: any) => {
      setaddLoader(true)
      var param = {
        cancellationreasonId: props.cancellationreasonId,
      }
      var res = await fetchData('admin/cancellationreasonasynclist', param)
      if (res.status == '200') {
        var data = res.data[0]
        setEnReason(data.en_reason)
        setRuReason(data.ru_reason)
        setUzReason(data.uz_reason)

        setaddLoader(false)
      } else {
        setaddLoader(false)
        toasterrormsg(res.message)
      }
    }

    useEffect(() => {
      if (props.cancellationreasonId > 0) {
        cancellationReasonDetails(props.cancellationreasonId)
      }
    }, [])

    // add / edit facility state end
    return (
      <Modal
        {...props}
        size='xl'
        aria-labelledby='contained-modal-title-hcenter'
        dialogClassName='maxwidth1000px'
        centered
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div className='d-flex align-items-center col-10'>
            <h4 className='fw-bold'>
              {cancellationreasonId !== '' &&
              cancellationreasonId !== null &&
              cancellationreasonId > 0
                ? t('Edit')
                : t('Add')}{' '}
              {t('Cancellation Reason')}
            </h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            className='stepper stepper-links d-flex flex-column'
            id='kt_create_account_stepper'
            data-kt-stepper='true'
          >
            <div className='mx-auto mw-600px w-100 py-10' id='kt_create_account_form'>
              <div>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  {t('English Reason')}
                </label>
                <input
                  type='text'
                  name='cancellationReasonEn'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder={t('English Reason')}
                  value={enReason}
                  onChange={(e: any) => setEnReason(e.target.value)}
                ></input>
                <label className='text-danger'>{error.enReasonError || ''}</label>
              </div>
              <div>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  {t('Russian Reason')}
                </label>
                <input
                  type='text'
                  name='cancellationReasonRu'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder={t('Russian Reason')}
                  value={ruReason}
                  onChange={(e: any) => setRuReason(e.target.value)}
                ></input>
                <label className='text-danger'>{error.ruReasonError || ''}</label>
              </div>
              <div>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  {t('Uzbek Reason')}
                </label>
                <input
                  type='text'
                  name='cancellationReasonUz'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder={t('Uzbek Reason')}
                  value={uzReason}
                  onChange={(e: any) => setUzReason(e.target.value)}
                ></input>
                <label className='text-danger'>{error.uzReasonError || ''}</label>
              </div>

              {/* action button start */}
              <div className={`d-flex pt-15 justify-content-center`}>
                <button
                  type='button'
                  className={`btn btn-lg btn-light-success me-3`}
                  onClick={props.onHide}
                >
                  {t('Cancel')}
                </button>

                <button
                  type='button'
                  disabled={disable}
                  className={`btn btn-lg btn-success monthBtn me-3`}
                  onClick={() => validate()}
                >
                  {!disable && t('Save')}
                  {disable && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      {t('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* action button end */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }

function ViewCancellationReason() {
  let t = Tr()
  const {menuId, menuIdAdd, menuIdDelete, menuIdEdit} = useMenuIdPermissions()

  const [showPopup, setShowPopup] = useState(false)
  const [cancellationReasonList, setCancellationReasonList] = useState([])
  const [orgCancellationReasonList, setOrgCancellationReasonList] = useState([])
  const [cancellationreasonId, setCancellationReasonId] = useState(0)
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)


  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('English Reason'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.en_reason}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.en_reason),
      },
      {
        name: t('Russian Reason'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.ru_reason}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.ru_reason),
        filter: true,
      },
      {
        name: t('Uzbek Reason'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.uz_reason}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.uz_reason),
        filter: true,
      },
      {
        name: t('Action'),
        cell: (row: any) => (
          <>
            {menuIdEdit ? (
              <button
                className='btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light'
                title='Edit'
                onClick={() => {
                  setShowPopup(true)
                  setCancellationReasonId(row.cancellationreasonId)
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            ) : (
              ''
            )}
            {menuIdDelete ? (
              <button
                className='btn btn-icon btn-wave waves-effect waves-light btn-sm btn-primary-light me-2'
                title='delete'
                onClick={() => deleteCancellationtReason(row.cancellationreasonId)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            ) : (
              ''
            )}
          </>
        ),
        width: '140px',
      },
    ],
    [t]
  )

  const deleteCancellationtReason = async (cancellationreasonId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete This Cancellation Reasons!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Ok'), // Custom OK button text
      cancelButtonText: t('Cancel'), // Custom Cancel button text
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          var param: any = {
            cancellationreasonId: String(cancellationreasonId),
          }

          const response = await fetchData('admin/deleteinterest', param)

          if (response.status == '200') {
            toastsuccessmsg(response.message)
            cancellationReasonListApiCall()
          } else {
            toasterrormsg(response.message)
          }
        } catch (error) {
          // Handle error as needed
          toasterrormsg('An error occurred while processing your request.')
        }
      }
    })
  }

  // call category list api
  const cancellationReasonListApiCall = async () => {
    var response: any = await fetchData('admin/cancellationreasonasynclist', {})

    if (response.status == '200') {
      var data = response.data
      setCancellationReasonList(response.data)
      setOrgCancellationReasonList(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | Cancellation Reasons'
    cancellationReasonListApiCall()
  }, [])

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Cancellation Reason')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end col-xl-8 ' data-kt-user-table-toolbar='base'>
          {menuIdAdd ? (
            <button
              type='button'
              className='btn btn-success monthBtn'
              onClick={() => setShowPopup(true)}
            >
              <KTIcon iconName='plus' className='fs-2' />
              {t('Add Cancellation Reason')}
            </button>
          ) : (
            ''
          )}
          {/* end::Add Department */}
        </div>
      </div>
    )
  }

  //search function
  const cancellationReasonSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setCancellationReasonList(orgCancellationReasonList)
    } else {
      var tmp: any = orgCancellationReasonList.filter(
        (item: any) =>
          (item.en_name != null &&
            item.en_name != '' &&
            item.en_name.toLowerCase() == text.toLowerCase()) ||
          (item.en_name != null &&
            item.en_name != '' &&
            item.en_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.ru_name != null && item.ru_name != '' && item.ru_name == text) ||
          (item.ru_name != null && item.ru_name != '' && item.ru_name.includes(text)) ||
          (item.uz_name != null && item.uz_name != '' && item.uz_name == text) ||
          (item.uz_name != null && item.uz_name != '' && item.uz_name.includes(text))
      )
      setCancellationReasonList(tmp)
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-12'>
            {orgCancellationReasonList.length > 0 ? (
              <>
                <DataTable
                  columns={column}
                  data={cancellationReasonList}
                  pagination
                  paginationServer={false}
                  subHeader={true}
                  subHeaderComponent={
                    <CustomHeader
                      search={searchTerm}
                      isfoc={focus}
                      customSearch={cancellationReasonSearch}
                    />
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: t('Rows Per Page'),
                  }}
                />
              </>
            ) : (
              <>
                <div className='text-center px-4'>
                  <div className='d-flex justify-content-center align-items-center flex-column my-10 py-20'>
                    <h2 className='fs-2x fw-bold'>{t('Welcome To Cancellation Reasons')}</h2>
                  </div>
                  <p className='text-gray-400 fs-4 fw-semibold '>
                    {t('There are no Cancellation Reasons')}
                  </p>
                  {menuIdAdd ? (
                    <Link
                      to='#'
                      className='btn btn-success monthBtn'
                      onClick={() => setShowPopup(true)}
                    >
                      {t('Add Cancellation Reasons')}
                    </Link>
                  ) : (
                    ''
                  )}
                  <br />
                </div>
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {showPopup && (
          <Popup
            show={showPopup}
            onHide={() => {
              setShowPopup(false)
              setCancellationReasonId(0)
                      cancellationReasonListApiCall()

            }}
            cancellationreasonId={cancellationreasonId}
          />
        )}
      </div>
    </>
  )
}

export default ViewCancellationReason
